import { useState, useEffect } from "react";
import { Form, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import "../../../../App.css";
import SurveyComponent from "../survey/SurveyComponent.jsx";
import CustomLoader from "../../common/customLoader/index.js";
import { useDispatch } from "react-redux";
import { feedbackRequestsPreviewThunk } from "../../../store/thunks/feedbackRequestsThunk.js";

const FeedbackRequestPreview = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [feedbackForm, setFeedbackForm] = useState({});
  const [form] = Form.useForm();
  const location = useLocation();

  const id = location.pathname.split("/")[3];
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const getFormDetail = async () => {
    const allKeys = Object.keys(localStorage);
    let removeItems = [
      "@secure.s.isSubMenuActive",
      "@secure.j.auditFormInput",
      "@secure.s.auditFormCall",
      "@secure.n.totalAuditedCount",
      "@secure.j.parameterSelectedList",
      "@secure.n.auditedQuestionScoreCount",
      "@secure.n.auditedQuestionCount",
      "@secure.j.countMap",
      "@secure.s.clickedLink",
      "@secure.s.auditScore",
      "@secure.j.timeStampsDetails",
      "@secure.n.weightageFlag",
      "@secure.j.updatedQMF",
      "@secure.s.savedAuditId",
      "@secure.j.savePayloadRequestParams",
    ];

    allKeys.forEach((key) => {
      if (removeItems.includes(key)) {
        localStorage.removeItem(key);
      }
    });

    const payload = { id };
    await dispatch(feedbackRequestsPreviewThunk(payload))
      .unwrap()
      .then((response) => {
        let parsedFeedbackForm = JSON.parse(response.formContent);
        let questions = parsedFeedbackForm?.elements;
        questions && setFeedbackForm(questions);
        setShowLoader(false);
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };

  useEffect(() => {
    getFormDetail();
    document.title = "Customer Satisfaction Survey";
  }, []);

  const headLine = feedbackForm?.elements?.meta?.headline;
  const surveyJSON = feedbackForm && feedbackForm;

  return (
    <div className="single-page surveyCom-container feedBackPreview">
      <CustomLoader showLoader={showLoader} />

      {secureLocalStorage.getItem("role") !== "" &&
        (secureLocalStorage.getItem("role") === "admin" ||
          secureLocalStorage.getItem("role") === "qc") && (
          <>
            <div className="surveyCom-outer-container">
              <div className="surveyCustom-inner-container">
                <span>{headLine}</span>

                {surveyJSON &&
                  surveyJSON.questions &&
                  surveyJSON.questions.length > 0 && (
                    <SurveyComponent
                      surveyJSON={surveyJSON}
                      id={id}
                      source="preview"
                    />
                  )}
              </div>
            </div>
          </>
        )}
    </div>
  );
};

export default FeedbackRequestPreview;
